import { SAVE, CLEAR } from "redux/actions/defaultStore";

const initialState = {
};

const defaultStoreReducer = (state = initialState, action) => {
  switch (action.type) {
    case SAVE:
      return {
        ...action.payload,
      };

    case CLEAR:
      return {
        ...initialState
      };

    default:
      return { ...state };
  }
};

export default defaultStoreReducer;
